<script setup>
  import { computed, nextTick, onMounted, ref, useTemplateRef, watch } from 'vue'
  import SwiperBase from '@/components/Utility/SwiperBase.vue';
  import { useElementBounding } from '@vueuse/core'
  import TimelineItem from '@/components/Ui/TimelineItem.vue';

  const activeIndex = ref(0)
  const indicatorOffset = ref(0)

  const props = defineProps({
    items: String
  })

  const items = computed(() => {
    if (!props.items) return false
    return JSON.parse(props.items)
  })

  const swiperRef = useTemplateRef('swiper')
  const timelineWrapper = useTemplateRef('timelineWrapper')

  watch(activeIndex, () => {
    swiperRef.value.swiper.slideTo(activeIndex.value)

    nextTick(() => {
      const activeNav = timelineWrapper.value.querySelector('.element-timeline-navigation-item.active')
      const { left } = useElementBounding(activeNav)
      indicatorOffset.value = left.value
    })
  })

  const updateActiveIndex = (index) => {
    activeIndex.value = index
  }

  onMounted(() => {
    const activeNav = timelineWrapper.value.querySelector('.element-timeline-navigation-item.active')

    nextTick(() => {
      const { left } = useElementBounding(activeNav)
      indicatorOffset.value = left.value
    })

  })

  const bodyStyle = computed(() => {
    if (!items.value || !swiperRef.value) return false
    const slides = swiperRef.value.swiper.slides
    nextTick(() => {
      const slideHeight = slides[activeIndex.value].offsetHeight
      const navigationHeight = timelineWrapper.value.offsetHeight
      return {
        maxHeight: `${navigationHeight + slideHeight + 100}px`
      }
    })

  })
</script>

<template>
  <section
    class="element-timeline ~mt-20/28 overflow-hidden"
    :style="bodyStyle"
  >
    <div
      class="element-timeline-navigation relative pb-10 lg:pb-8"
      ref="timelineWrapper"
    >
      <div
        class="element-timeline-indicator hidden lg:block absolute bottom-6 lg:bottom-0 translate-y-1/2"
        :style="{ left: `${indicatorOffset + 5}px` }"
      >
        <AppIcon
          name="Signet"
        />
      </div>
      <div
        class="element-timeline-indicator w-full flex items-center justify-center pr-10 lg:hidden absolute bottom-6 lg:bottom-0 translate-y-1/2"
      >
        <AppIcon
          name="Signet"
        />
      </div>
      <SwiperBase
        theme="timelineNavigation"
        @handleSlideChange="updateActiveIndex"
      >
        <template #slides>
          <div
            class="element-timeline-navigation-item swiper-slide w-fit whitespace-nowrap opacity-80 hover:opacity-100 transition-all duration-500 text-body cursor-pointer ~†ext-xs/sm tracking-wider"
            v-for="(item, index) in items"
            :key="index"
            @click="activeIndex = index"
            :class="activeIndex === index ? 'active font-bold' : ''"
          >
            {{ item.year }}
          </div>
        </template>
      </SwiperBase>
    </div>
    <SwiperBase
      theme="timeline"
      ref="swiper"
    >
      <template #slides>
        <TimelineItem
          v-for="(item,index) in items"
          :key="index"
          :item="item"
        />
      </template>
    </SwiperBase>
  </section>
</template>

<style lang="scss" scoped>
  .element-timeline-indicator {
    @apply transition-all duration-500 ease-in-out;
  }
  .element-timeline-navigation {
    &::before {
      content: '';
      @apply h-px w-full bg-headline bg-opacity-30 absolute bottom-6 lg:bottom-0 right-0 left-0 z-[11];
    }
  }
</style>
